module.exports = __webpack_public_path__ + "media/images/office365-7971047901cff3facbed301e7e6358ee.svg";